import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';
import { useApplyThemeClass } from '@/hooks/useTheme';
import { PwaUpdater } from '@/pwa/PwaUpdater';
import { TENANT } from '@/routing/tenant';
import { GlobalRoutes } from '@/routes/GlobalRoutes';
import { TenantRoutes } from '@/routes/TenantRoutes';

/**
 * Which route tree is mounted is decided by the first path segment, once, before
 * the router exists — see `@/routing/tenant`. `basename` cannot change after
 * mount, so this is not a runtime switch: it is fixed for the page load, and
 * moving between the two is a full navigation.
 */
function ThemedRoutes() {
  useApplyThemeClass();
  return TENANT.mode === 'tenant' ? <TenantRoutes /> : <GlobalRoutes />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={TENANT.basename}>
        <ThemedRoutes />
        {/* Inside the router so it can suppress itself on public /p/* pages. */}
        <PwaUpdater />
      </BrowserRouter>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
    </QueryClientProvider>
  );
}
